/**
 * The page header for every LISTING route — the browse containers and the
 * Search App. (item 15)
 *
 * One component because the two had drifted into two products. Browse rendered
 * Volto's stock `h1.documentFirstHeading` (28px, medium weight, a hard 2px
 * rule); /search rendered a bespoke hero (40px, bold, hairline rule) with a
 * lede browse had no equivalent of. A reader moving from "browse Archived
 * Standards" to "search for welding" should not feel they have changed site.
 *
 * The title is the page's ONLY h1: on browse this renders instead of the stock
 * title block, not beside it (see the Title block shadow), so the document
 * outline stays single-rooted and screen readers get one page heading.
 *
 * `lede` is optional but supplied on both routes — it is the line that says
 * what this list actually contains, which is precisely the question a bare
 * "Documents" leaves open.
 */
import React from 'react';
import PropTypes from 'prop-types';

const PageHeader = ({ title, lede }) => (
  <header className="pp-page-head">
    <h1 className="pp-page-head__title">{title}</h1>
    {lede ? <p className="pp-page-head__lede">{lede}</p> : null}
  </header>
);

PageHeader.propTypes = {
  /** The page's heading. On browse this is the active category, not the container. */
  title: PropTypes.node.isRequired,
  /** One sentence on what this list contains. */
  lede: PropTypes.node,
};

export default PageHeader;
